import React, { useEffect } from 'react';

const NOTIFICATION_DURATION = 2500;

/**
 * 通知コンポーネント
 */
export default function Notification({
  message,
  open,
  onClose
}) {
  useEffect(() => {
    // openがtrueになったらn秒後にonCloseを呼び出す
    if (open) {
      const timer = setTimeout(onClose, NOTIFICATION_DURATION);
      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  // openがfalseなら（falseになったら）何も表示しない
  if (!open) return null;

  return (
    <div className="notification">
      {message}
    </div>
  );
}